module.exports = __webpack_public_path__ + "./Kate_pbw_68e4ee232970733d48fddbeabc8f119a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Kate_pbw.png
// module id = 593
// module chunks = 0